export default {
  getCart: (state) => {
    return state.cart;
  },

  getMethod: (state) => {
    return state.method;
  },

  getCardBrand: (state) => {
    return state.cardBrand;
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/components/store/getters.js